<template>
  <div class="iv-home-index">
    <BennerBox
      @moreClick="moreClick"
      @onDetail="onDetail"></BennerBox>
    <div class="iv-home-wrap">
      <!-- 党建引领 & 廉洁园地 -->
      <Row class="iv-main-width">
        <CommonBlock
          :formItem="item"
          v-for="(item, inx) in layout1"
          :key="item.code + '' + inx"
          :class="(inx % 2 == 0) ? '' : 'iv-pull-right'"
          @moreClick="moreClick"
          @onDetail="onDetail"
        />
      </Row>
      <!-- 工会动态 & 青团之声 -->
      <div class="iv-block-bg">
        <Row class="iv-main-width">
          <CommonBlock
            :formItem="item"
            v-for="(item, inx) in layout2"
            :key="item.code + '' + inx"
            :class="(inx % 2 == 0) ? '' : 'iv-pull-right'"
            @moreClick="moreClick"
            @onDetail="onDetail"
          />
        </Row>
      </div>
      <!-- 创业创新 & 文化阵地 -->
      <Row class="iv-main-width">
        <CommonBlock
          :formItem="item"
          v-for="(item, inx) in layout3"
          :key="item.code + '' + inx"
          :class="(inx % 2 == 0) ? '' : 'iv-pull-right'"
          @moreClick="moreClick"
          @onDetail="onDetail"
        />
      </Row>
      <!-- 榜样力量 -->
      <div class="iv-main-width iv-power-box">
        <CommonTitle :icon="layout4.icon" :main="layout4.main" :text="layout4.text" @more="moreClick(layout4)"/>
        <Row :gutter="40" type="flex">
          <Col
            class="iv-p-t-8 iv-m-t-24 iv-pointer"
            v-for="(item, inx) in layout4.list.slice(0, 3)"
            :key="layout4.code + '' + item.code + '' + (inx + 1)"
            span="8"
          >
            <img :src="getImgPath(item.blogPic)"  @error="nofind" @click="onDetail(item)"/>
            <p>
              <span class="iv-ellipsis-1 iv-m-20 iv-fs-20 iv-fc-85 iv-fw-b iv-hover-color" @click="onDetail(item)">{{ item.title }}</span>
            </p>
          </Col>
        </Row>
      </div>
      <!-- 公益活动 -->
      <div class="iv-main-width iv-power-box">
        <CommonTitle :icon="layout5.icon" :main="layout5.main" :text="layout5.text" @more="moreClick(layout5)"/>
        <Carousel v-model="carouselValue" autoplay :autoplay-speed="5000" dots="outside">
          <!-- autoplay :autoplay-speed="5000" -->
          <CarouselItem v-for="(group, inx) in layout5.list" :key="layout5.code + '' + (inx + 1)">
            <Row :gutter="40" type="flex">
              <Col
                class="iv-p-t-8 iv-m-t-24 iv-pointer"
                v-for="(item, inx) in group"
                :key="layout5.code + '' + item.code + '' + (inx + 1)"
                span="6"
              >
                <img :src="getImgPath(item.blogPic)"  @error="nofind" @click="onDetail(item)"/>
                <p class="iv-p-20">
                  <span class="iv-ellipsis-1 iv-fs-20 iv-fc-85 iv-fw-b iv-hover-color"  @click="onDetail(item)">{{ item.title }}</span>
                  <span class="iv-ellipsis-1 iv-m-t-12 iv-fs-16 iv-fc-65 iv-hover-color">{{ item.desc }}</span>
                </p>
              </Col>
            </Row>
          </CarouselItem>
        </Carousel>
      </div>
    </div>
  </div>
</template>
<script>
import CommonBlock from './components/common-block'
import CommonTitle from './components/common-title'
import BennerBox from './components/benner-box'
export default {
  components: { CommonBlock, CommonTitle, BennerBox },
  props: ['navData'],
  data () {
    return {
      carouselValue: 0,
      layout1: [],
      layout2: [],
      layout3: [],
      layout4: {
        list: []
      },
      layout5: {
        list: []
      },
      navMap: {}
    }
  },
  watch: {
    navData (val) {
      this.navMap = val
    }
  },
  created () {
    this.setLayoutList()
  },
  methods: {
    setLayoutList () {
      this.getList()
    },
    getList() {
      this.$ajax({
        url: 'api-qixuan/cms/front/getHome',
        method: 'get',
        data: {
          code: 'party_lead,probity_garden,union_news,youth_league_voice,pioneer_innovation,culture_position,model_strength,public_benefit_activities',
          rowNum: '5'
        }
      }).then(({data}) => {
        this.layout1 = [
          { type: 'mix', code: 'party_lead', icon: 'sixiangyinling', main: '党建', text: '引领', list: data.data['party_lead'] || [] },
          { type: 'mix', code: 'probity_garden', icon: 'xuexiyuandifill1', main: '廉洁', text: '园地', list:  data.data['probity_garden'] || [] }
        ]
        this.layout2 = [
          { type: 'text', code: 'union_news', icon: '-gonghui', main: '工会', text: '动态', list: data.data['union_news'] || [] },
          { type: 'text', code: 'youth_league_voice', icon: 'rutuan', main: '青团', text: '之声', list: data.data['youth_league_voice'] || [] }
        ]
        this.layout3 = [
          { type: 'img', code: 'pioneer_innovation', icon: 'quanzongdongtai', main: '创业', text: '创新', list: data.data['pioneer_innovation'] || [] },
          { type: 'img', code: 'culture_position', icon: 'icon_banjiwenhua', main: '文化', text: '阵地', list: data.data['culture_position'] || [] },
        ]
        this.layout4 = { type: 'other', code: 'model_strength', icon: 'quanzongdongtai', main: '榜样', text: '力量', list: data.data['model_strength'] || [] }
        this.layout5 = { type: 'other', code: 'public_benefit_activities', icon: 'quanzongdongtai', main: '公益', text: '活动', list: this.sliceArrFn(data.data['public_benefit_activities'] || []) }
      })
    },
    // 更多点击
    moreClick (item) {
      const { href } = this.$router.resolve({
        name: item.code,
        query: {
          categoryCode: item.code,
          categoryName: this.navMap[item.code].categoryName,
          categoryId: this.navMap[item.code].categoryId,
          categoryType: this.navMap[item.code].categoryType
        }
      })
      window.open(href, '_blank')
    },
    // 详情点击
    onDetail (detail) {
      if (detail.columnCode == 'public_benefit_activities') {
        const { href } = this.$router.resolve({
          name: 'newsDetail',
          query: {
            infoId: detail.forwardId
          }
        })
        window.open(href, '_blank')
      } else {
        const { href } = this.$router.resolve({
          name: 'newsDetail',
          query: {
            infoId: detail.id
          }
        })
        window.open(href, '_blank')
      }

    },
    // 一维数组分割为二维数组
    sliceArrFn (array) {
      var result = []
      var size = 4
      for (var x = 0; x < Math.ceil(array.length / size); x++) {
        let start = x * size
        let end = start + size
        result.push(array.slice(start, end))
      }
      return result
    },
    getImgPath(imageUrl) {
      return process.env.VUE_APP_BASE_DOWNLOAD_IMAGE_API + imageUrl
    },
    nofind () {
      var img = event.srcElement
      img.src = require('@/assets/images/new-home/static/img2.png')
      img.onerror = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/new-blue/variable.scss';
@media screen and (max-width: 1920px) {
  .iv-home-wrap {
    min-width: 1200px !important;
  }
}
.iv-home-wrap {
  background-color: #fff;
  .iv-block-bg {
    width: 100%;
    background: #F7FCFE url('~@/assets/images/new-home/ghqtbg.png') no-repeat;
    background-size: 100%;
  }
}
// project
.iv-power-box {
  padding-bottom: 40px;
  img {
    width: 100%;
    vertical-align: middle;
  }
  p {
    overflow: hidden;
    background-color: #F5F7FA;
    span {
      max-height: 28px;
    }
  }
}
/deep/ .ivu-carousel-dots-outside {
  margin-top: 40px;
}
/deep/ .ivu-carousel-dots li button {
  width: 8px;
  height: 8px;
  background-color: rabg(0, 0, 0, 0.25);
  border-radius: 50px;
}
/deep/ .ivu-carousel-dots li.ivu-carousel-active>button {
  width: 20px;
  background-color: $iv-main-color;
  border-radius: 7px;
}
</style>
